import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm, FormProvider } from 'react-hook-form';
import { sendEmail, createActivityQuoteDB } from '../API/Model';
import { Redirect } from 'react-router';
import PageTitle from 'components/Additional/PageElements/PageTitle/PageTitle';
import Footer from 'components/Additional/Footer/Footer';
import SfiLoader from 'components/Additional/SfiLoader/SfiLoader';
import YourInfoFormContent from 'components/Additional/YourInfoForm/YourInfoFormContent';

import 'components/styles/styles.css';
import styles from './QuickQuoteReferal_page.module.css';

function QuickQuoteReferal() {
	const PAGE_NAME = 'QuickQuoteReferal';

	let history = useHistory();

	const [isLoading, setIsLoading] = useState(false);

	const methods = useForm({
		defaultValues: {
			first: '',
			mi: '',
			last: '',
			email: '',
			phone: '',
			birth: '',
			contactTime: '0',
			consentAccepted: false,
		},
		mode: 'onChange',
	});

	const { handleSubmit } = methods;

	function mapOwnerType() {
		const ownerType = localStorage.getItem('owner_type');
		if (ownerType === 'OwnerCondo') return 'Condo';
		else if (ownerType === 'Renter') return 'Renter';
		else if (ownerType === 'Landlord') return 'Landlord';
		else if (ownerType === 'OwnerMobileHome') return 'Mobile Home';
		else return '';
	}

	async function databaseUpdate(data) {
		await fetch(
			`${window.APP_CONFIG.INTERNAL_API_URL}/portal/createQuoteDB`,
			{
				method: 'POST',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					Quote_Number: '',
					Email: data.email,
					Insured_First_Name: data.first,
					Insured_Last_Name: data.last,
					CoApplicant_First_Name: '',
					CoApplicant_Last_Name: '',
					Address: '',
					Zip_code: '',
					Quote_Status_code: 'NONE',
					Session_id: localStorage.getItem('session_id'),
				}),
			}
		);

		createActivityQuoteDB('QuickQuoteReferal', 'NAV', 'Submit button');
	}

	async function sendDataByEmail(data) {
		let formData = new FormData();
		formData.append('email', data.email);
		formData.append('subject', 'Security First Insurance Quick Quote');
		formData.append('first_name', data.first);
		formData.append('middle_name', data.mi);
		formData.append('last_name', data.last);
		formData.append('type', 'email_a');
		formData.append('pdf_url', 'null');
		formData.append(
			'contact_email',
			localStorage.getItem('brand_email_no_quote')
		);
		formData.append('phone', window.APP_CONFIG.CONTACT_PHONE);
		formData.append('customer_phone', data.phone);
		formData.append('customer_contact_time', data.contactTime);
		formData.append('customer_email', data.email);
		formData.append('birth_date', data.birth);
		formData.append('business_source', window.APP_CONFIG.BUSINESS_SOURCE);

		await sendEmail(formData);
		localStorage.setItem('status', 'COMP');
	}

	useEffect(() => {
		createActivityQuoteDB(PAGE_NAME, 'PL', 'QuickQuoteReferal page loaded');
		localStorage.setItem('current_page', PAGE_NAME);
	}, []);

	const onSubmit = async (formData) => {
		setIsLoading(true);
		databaseUpdate(formData);

		if (localStorage.getItem('status') !== 'COMP') {
			await sendDataByEmail(formData);
		}

		setIsLoading(false);
		history.push('/ThankYou');
	};

	if (localStorage.getItem('status') === 'COMP') {
		return <Redirect push to={'/ThankYou'} />;
	} else {
		return (
			<FormProvider {...methods}>
				<div className="base-wrapper">
					{isLoading ? (
						<div className="internal_loader">
							<SfiLoader />
						</div>
					) : (
						<div className={styles.yourinfo_text_wrapper}>
							<PageTitle
								titleContent={
									<>
										Security First Insurance can quote 95%
										of properties in Florida
									</>
								}
								titleDescription={
									<>
										<p>
											{`We're happy to assist you with an
										estimate for a ${mapOwnerType()} Policy.`}
										</p>
										<p>{`Our Florida-based team members are standing by
								to generate your custom ${mapOwnerType()} quote.`}</p>
									</>
								}
							/>
							<PageTitle
								titleContent={<>Get your quote</>}
								titleDescription={
									<p>
										{`Call us at ${window.APP_CONFIG.CONTACT_PHONE} to
								get your quote. Complete the form below if you'd
								like us to reach out to you:`}
									</p>
								}
							/>
							<form onSubmit={handleSubmit(onSubmit)}>
								<YourInfoFormContent />
							</form>
							<Footer />
						</div>
					)}
				</div>
			</FormProvider>
		);
	}
}

export default QuickQuoteReferal;
